export default {
  castle: '城堡作为一个结盟城镇，维护着埃拉西亚的和平。城堡的军队主要由人类武士组成，也与狮鹫结成联盟，并受到天使的庇佑。',
  rampart: '壁垒是一个结盟城镇，代表了阿维利。壁垒是由恩洛斯结盟保卫战中未遭破坏的荒野地区的生物建立的。',
  tower: '塔楼是一个结盟城镇，代表着布拉卡达。塔楼的人口是由掌握强大魔法、当场制造、或通过古老契约与城镇结盟的生物组成。',
  necropolis: '墓园是一个邪恶结盟城镇，它被亡灵生物所占领和统治，代表着迪迦。他们是亡灵法师和死亡骑士的天然基地。',
  dungeon: '地下城是邪恶结盟城镇，作为妖术师和地下领主发动征服财富和权力战役的基地，代表了尼贡。与之志同道合的生物与其结为盟友，其他地下城的生物则对主人惟命是从。',
  stronghold: '据点是一个中立的结盟城镇，由部落联盟建立，代表了克鲁洛德。',
  fortress: '要塞是一个中立的结盟城镇，代表泰塔利亚。要塞建立在沼泽的边缘地区，他们的军队主要由致命的生物组成：诞生于沼泽，之后被制服并受战争训练。',
  inferno: '地狱是一个邪恶结盟城镇，代表着伊欧弗。在地表受到冥界摧残的埃拉西亚区域可以发现地狱。魔鬼和异教徒与这些城镇站在一个不稳定的联盟中。',
  conflux: '元素城的魔法将席卷大陆。',
  cove: '港口是船长和航海家英雄的基地。',
}
